const defaults = {
    imageUrl: '',
    showImagePreviewer: false
}

export default (state = defaults, action) => {
    switch (action.type) {
        case 'SHOW_IMAGE_PREVIEWER':
            return {...state, imageUrl: action.payload.imageUrl, showImagePreviewer: true}
        case 'HIDE_IMAGE_PREVIEWER':
            return {...state, showImagePreviewer: false}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/imagePreviewer.js